import { z } from 'zod';
/**
 * Lenient URL validation: accepts common formats like "example.com", "www.example.com",
 * "http://example.com", "https://example.com". Normalizes by prepending https:// if missing protocol.
 */
const websiteSchema = z
    .string()
    .max(500)
    .refine((val) => {
    if (!val)
        return true;
    // If it has a protocol, validate as URL
    if (/^https?:\/\//i.test(val)) {
        try {
            new URL(val);
            return true;
        }
        catch {
            return false;
        }
    }
    // Otherwise, prepend https:// and try
    try {
        new URL(`https://${val}`);
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Invalid website URL' })
    .optional();
export const createVendorSchema = z.object({
    businessName: z.string().min(1).max(255),
    contactName: z.string().max(255).optional(),
    email: z.string().email().optional(),
    phone: z.string().max(50).optional(),
    address: z.string().max(500).optional(),
    city: z.string().max(100).optional(),
    state: z.string().max(100).optional(),
    zipCode: z.string().max(20).optional(),
    country: z.string().max(100).optional(),
    taxId: z.string().max(50).optional(),
    website: websiteSchema,
    notes: z.string().max(2000).optional(),
});
// Update fields are nullable: the edit panels send null to clear a field
export const updateVendorSchema = z.object({
    businessName: z.string().min(1).max(255).optional(),
    contactName: z.string().max(255).nullable().optional(),
    email: z.string().email().nullable().optional(),
    phone: z.string().max(50).nullable().optional(),
    address: z.string().max(500).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    state: z.string().max(100).nullable().optional(),
    zipCode: z.string().max(20).nullable().optional(),
    country: z.string().max(100).nullable().optional(),
    taxId: z.string().max(50).nullable().optional(),
    website: websiteSchema.nullable(),
    rating: z.number().min(0).max(5).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isActive: z.boolean().optional(),
});
export const deleteVendorSchema = z.object({
    reassignToVendorId: z.string().uuid().nullable().optional(),
});
export const addVendorCategorySchema = z.object({
    vendorCategoryId: z.string().uuid(),
    isPrimary: z.boolean().optional(),
});
export const addVendorContactSchema = z.object({
    userId: z.string().uuid(),
    role: z.string().max(100).optional(),
    isPrimary: z.boolean().optional(),
});
export const vendorEmailAttachmentSchema = z.object({
    s3Key: z.string().min(1).max(1024),
    fileName: z.string().min(1).max(255),
    mimeType: z.string().min(1).max(100),
});
export const sendVendorEmailSchema = z.object({
    vendorIds: z.array(z.string().uuid()).min(1).max(100),
    subject: z.string().min(1).max(500),
    bodyHtml: z.string().min(1).max(200_000),
    attachments: z.array(vendorEmailAttachmentSchema).max(10).optional(),
});
//# sourceMappingURL=vendor.js.map